import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBAdditionalServices, withFTTBServiceMapper } from 'pages/Internet/store/selectors/servicesSelectors';
import { ServiceGridItem } from '../../components';

export const ServiceListGrid = compose(
  connect((state) => ({
    shouldRender: !!getFTTBAdditionalServices(state).length,
  })),
  withFTTBServiceMapper,
  withRenderFlag,
)(({ children }) => children);

ServiceListGrid.Item = ServiceGridItem;
ServiceListGrid.ItemContainer = ({ children }) => children;
